import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { CiCalculator1 } from "react-icons/ci";
import { AiOutlineContacts } from "react-icons/ai";
import ReportModal from "./ReportModal";
import { RiCustomerService2Fill } from "react-icons/ri";

export default function RightBar() {
    // const [isModalOpen, setIsModalOpen] = useState(false);

    // const handleOpenModal = () => setIsModalOpen(true);
    // const handleCloseModal = () => setIsModalOpen(false);

    const menuItems = [
        { icon: <FaBars size={35} />, label: "Beranda", href: "/" },
        { icon: <CiCalculator1 size={35} />, label: "Simulasi", href: "/#simulation" },
        { icon: <AiOutlineContacts size={35} />, label: "Kontak", href: "/#contact" },
        { 
            icon: <RiCustomerService2Fill size={35} />, 
            label: "Pengaduan", 
            href: "/pengaduan", 
            // onClick: handleOpenModal 
        },
    ];

    return (
        <>
            <div className="fixed right-0 top-1/2 transform -translate-y-1/2 flex-col gap-4 z-40 hidden md:flex">
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        className="group relative flex justify-end"
                    >
                        <Link
                            to={item.href}
                            // onClick={(e) => {
                            //     if (item.onClick) {
                            //         e.preventDefault();
                            //         item.onClick();
                            //     }
                            // }}
                            className="flex items-center justify-start w-14 h-14 bg-bprYellow text-bprDarkBlue cursor-pointer
                            overflow-hidden rounded-l-lg hover:w-40 transition-all duration-300 ease-in-out"
                        >
                            <div className="flex items-center gap-2 pl-2 whitespace-nowrap">
                                {item.icon}
                                <span
                                    className="text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                >
                                    {item.label}
                                </span>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>

            {/* <ReportModal isOpen={isModalOpen} onClose={handleCloseModal} /> */}
        </>
    );
}
